module.exports = __webpack_public_path__ + "img/logo-casa-bco2.e7e552f6.svg";